module.exports = __webpack_public_path__ + "media/images/map-icons/motorcycle-6865a7b0c500fc8a0ea8a6d61c24fb99.svg";